<template>
  <div class="bto-sb-widget bto-sb-widget-category bto-sb-widget-horse-details bto-sb-sports-icon bto-sb-sports-icon bto-sb-widget-horse-tricast" :class="selectedSportIcon()">
    <video-streaming-widget v-if="useVideoWidget" />
    <div class="bto-sb-widget bto-sb-widget-prematch">
    <div class="bto-sb-widget-title bto-sb-widget-nav-icon">
      <h3>{{t('HR.RaceDetails')}}</h3>
      <ul class="bto-sb-widget-nav-icon" >
        <li>
          <a :class="tabCollapsed ? 'bto-sb-widget-nav-icon-expand' : 'bto-sb-widget-nav-icon-collapse'"
              @click="toggleCollapse()" :title="t('Global.Collapse')">
          </a>
        </li>
        <li><a :title="t('Public.Close')" class="bto-sb-widget-nav-icon-close" @click="closeTournamentTab()"></a></li>
      </ul>
    </div>
    <div class="bto-sb-widget-title-small bto-sb-widget-title-flag" v-if="HRcategory.length > 0">
      <span v-if="category" class="bto-sb-flag" :class="categoryCss"></span>
      <h3 v-if="name">{{name}}</h3>
      <h4 v-if="category">{{category}}</h4>
      <div class="bto-sb-horse-racingshow">
        <div class="bto-sb-form-select">
          <select @change="selectDate()" v-model="date">
              <option :value=hrTimeFilter.TODAY>{{t('Public.Today')}}</option>
              <option :value=hrTimeFilter.TOMORROW>{{t('Mobile.Tomorrow')}}</option>
              <!-- <option :value=hrTimeFilter.ANTE_POST>{{t('HR.AntePost')}}</option> -->
              <option :value=hrTimeFilter.RESULTS>{{t('HR.ResultsYesterday')}}</option>
          </select>
          <div class="bto-sb-form-select-arrow"></div>
        </div>
        <div class="bto-sb-horse-racingshow-info" v-if="showWeatherAndTrackData"><span>{{t('HR.Track')}}</span>{{raceOdds.track || '--'}}</div>
        <div class="bto-sb-horse-racingshow-info" v-if="showWeatherAndTrackData"><span>{{t('HR.Weather')}}</span>{{raceOdds.weather || '--'}}</div>
      </div>
    </div>
    <div class="bto-sb-widget-content" v-show="!tabCollapsed">
      <empty-state v-if="HRcategory.length === 0 && outrightSports.length === 0" 
       :message="t(loading ? 'Mobile.LoadingMore' :'HR.NoEvents')" 
       :hideShadow="loading ? true : false" 
       :icon-class="loading ? loadingSpinner : emptyStateIcon" />
      <div class="bto-sb-event-sports" v-if="HRcategory.length > 0">
        <div class="bto-sb-scrolling-menu">
          <ul>
            <li v-for="(race,idx) in this.HRcategory[0].tabs[0].horseRaces" 
              :class="{'bto-sb-event-sports-active': raceTimeFilter === race.raceNumber}" 
              :key="idx">
              <a @click="selectTime(race.raceNumber,idx,race.outrightID,race.raceStatusId)" 
                :class="getIconStatusClass(race.raceStatusId)">
                {{race.raceNumber}}
                <span>{{race.time}}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="bto-sb-horse-racinginfo" v-if="HRcategory.length > 0">
        <div class="bto-sb-horse-event-status">
          <span :class="getIconStatusClass(raceOdds.raceStatusId)">{{raceOdds.raceStatusName}}</span>
        </div>
        <div class="bto-sb-horse-racingshow">
          <div class="bto-sb-horse-racingshow-info">
            <span>{{t('HR.Distance')}}</span>{{raceOdds.distance}}
          </div>
          <div class="bto-sb-horse-racingshow-info" v-if="showWeatherAndTrackData">
            {{raceOdds.trackType}}, {{raceOdds.RaceType}}
          </div>
        </div>
        <!-- <div class="bto-sb-horse-racinginfo-expert">
          <span>Expert Tip</span>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
        </div> -->
        <div class="bto-sb-horse-racingshow">
          <div class="bto-sb-horse-racingshow-info">
            {{getEachWayTextHr()}}
          </div>
          <div v-if="raceOdds.matchOdds" class="bto-sb-horse-racingshow-info">{{raceOdds.matchOdds.length}} {{t('HR.Runners')}}</div>
           <span v-if="raceOdds.handicap === 'Yes'" class="bto-sb-horse-racingshow-info">{{ t("HR.Handicap") }}</span>
        </div>
        <div class="bto-sb-horse-market-menu" v-if="showForeCastTricats" >
          <ul>
            <li @click="selectBetType(BET_TYPES.WINNER_EW) "><a :class="{'bto-sb-horse-market-menu-active': betType === BET_TYPES.WINNER_EW }">{{ t('Public.RaceWinner') }}</a></li>
            <li @click="selectBetType(BET_TYPES.FORECAST)"><a  :class="{'bto-sb-horse-market-menu-active': betType === BET_TYPES.FORECAST}">{{ t('Public.Forecast') }}</a></li>
            <li @click="selectBetType(BET_TYPES.TRICAST)" ><a :class="{'bto-sb-horse-market-menu-active': betType === BET_TYPES.TRICAST}">{{ t('Public.Tricast') }}</a></li>
          </ul>
        </div>
        <div class="bto-sb-horse-market-container" v-if="betType !== 1">
          <div class="bto-sb-horse-market-info">{{ getRaceDescription }}</div>
          <div class="bto-sb-horse-market-filter">
              <button @click="addCastToBetslip" :class="['bto-sb-horse-market-btn', {'bto-sb-horse-market-btn-disabled' : !btnActive }]">
                {{ t(getBtnForeCastTextHr) }}
              </button>
              <!-- <div class="bto-sb-form-select">
                  <select>
                      <option>Number</option>
                      <option>Odd</option>
                  </select>
                  <div class="bto-sb-form-select-arrow"></div>
              </div> -->
          </div>
      </div>
      </div>
      <div v-if="HRcategory.length > 0" class="bto-sb-widget-horse-events" :class="getOddsStatusClass(date === hrTimeFilter.ANTE_POST ? hrTimeFilter.ANTE_POST : raceOdds.raceStatusId)">
        <empty-state v-if="horseRacesRunners[0].length === 0" 
         :message="t(loading?'Mobile.LoadingMore':'HR.NoRunners')" 
         :hideShadow="loading ? true : false" 
         :icon-class="loading ? loadingSpinner : emptyStateIcon" />
        <ul class="bto-sb-horse-events-items">
          <li class="bto-sb-horse-events-item" v-for="(items,idx) in horseRacesRunners" :key="idx" >
            <div class="bto-sb-horse-event" >
              <div class="bto-sb-horse-event-content"  v-if="date !== hrTimeFilter.ANTE_POST"  >
                <div class="bto-sb-horse-event-item-nav" v-if="betType !== 1">
                    <div class="bto-sb-horse-event-nav-labels">
                        <div class="bto-sb-event-nav-label">
                            <span>{{ t('Public.RaceMarketFirst') }}</span>
                        </div>
                        <div class="bto-sb-event-nav-label">
                            <span>{{ t('Public.RaceMarketSecond') }}</span>
                        </div>
                        <div class="bto-sb-event-nav-label" v-if="betType === 3">
                            <span>{{ t('Public.RaceMarketThird') }}</span>
                        </div>
                        <div class="bto-sb-event-nav-label">
                            <span>{{ t('Public.RaceMarketAny') }}</span>
                        </div>
                    </div>
                </div>
              <hr-race-odds  v-for="(item,jdx) in items" :key="`${jdx}_${item.runnerNumber}`" 
                :runner="item" 
                :status="raceOdds.raceStatusId" 
                :selectedSport="selectedSport" 
                :raceRegion="raceOdds.raceRegion" 
                :raceType="raceOdds.RaceType" 
                :tournamentId ="tournamentId"
                :betType="betType" 
                @toggleCast="toggleCast" />
              </div>
              <antepost-race-odds v-if="date === hrTimeFilter.ANTE_POST"  :runner="item" :status="raceOdds.raceStatusId" />
            </div>
          </li>
        </ul>
      </div>
      <non-runners v-if="nonRunners.length" :items="nonRunners.slice(0,3)" :selectedSport="selectedSport" :raceType="raceOdds.RaceType"/>
    </div>
    </div>
    <template v-if="HRcategory.length === 0 && outrightSports.length > 0" >
      <div
      v-for="(market, idx) in outrightSports[0].outrights"
      :key="idx"
      class="bto-sb-element"
      v-show="!tabCollapsed"
      >
        <div v-if="market.outcomes.length" class="bto-sb-widget-title-small">
          <h4>{{market.name}}</h4>
          <div class="bto-sb-category-outrights-dates">
            <span class="bto-sb-category-outrights-end-date">{{t("OutrightEndDate")}}: {{market.endDate}}</span>
            <span v-if="showBettingEndDate" class="bto-sb-category-outrights-end-betting">{{t("OutrightEndBetting")}}: {{market.bettingEndDate}}</span>
          </div>
        </div>
        <div v-if="market.outcomes.length" class="bto-sb-widget-content">
          <div class="bto-sb-event-odds-content">
            <div class="bto-sb-event-outrights-odds">
              <div class="bto-sb-event-outrights-odds-col">
                <match-odd-component
                v-for="(outcome, idx) in market.outcomes.slice(0, Math.ceil(market.outcomes.length / 2))"
                :key="idx"
                :match="market"
                :outcome="outcome"
                :isOutright="true"
                />
              </div>
              <div class="bto-sb-event-outrights-odds-col">
                <match-odd-component
                v-for="(outcome, idx) in market.outcomes.slice(Math.ceil(market.outcomes.length / 2), market.outcomes.length)"
                :key="idx"
                :match="market"
                :outcome="outcome"
                :isOutright="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div> 
    </template>
   </div>
</template>

<script>
  import { EventBus } from '../../../services/event-bus-service';
  import DateFilterService from '../../../services/date-filter-service';
  import { TournamentOutrightsRequestService } from '../category-outrights/service-tournament-outrights';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import HorseRacingModel from './horse-racing-model';
  import HorseRacingOutrightsRequestService from './service-horse-racing-tournament';
  import store from '../../../store';
  import HrRaceOdds from './hr-race-odds.vue';
  import NonRunners from './non-runners-hr.vue';
  import AntepostRaceOdds from './antepost-race-odds.vue';
  import HorseRacingOddsDetails from './hr-odds-details';
  import HRMatchModel from './hr-match-model';
  import { HORSE_RACING_STATUSES_CLASES, HORSE_RACING_EVENT_STATUS_CLASSES, HORSE_RACING_TIME_FILTERS, HORSE_RACING_STATUSES } from '../../../models/enums/horse-racing-const';
  import { chunkArrayExact } from '../../../services/utils';
  import { toggleCastItem, resetRaceCast, raceCastState, addItem, placeQuickBet } from '@bto-services/betslip-core';
  import FullSportModel from '../../../models/full-sport-model';
  import MatchOddComponent from '../../common/match/match-odd-component';
  import { useForeCastTricast } from '@bto-services/api/shared/sb-settings';
  import { formatOddDisplay } from '@bto-services/utils';
  import { mapCastToBetslip } from 'bto-models/betslip';
  import { RACING_BETTING_TYPES, RACE_CAST_ITEM_TYPE } from 'bto-models/match/races/const';
  import { showBetslipValidation } from '@bto-services/modal';

  export default {
    name: 'CategoryTabHR',
    components: {
      EmptyState,
      HrRaceOdds,
      NonRunners,
      AntepostRaceOdds,
      MatchOddComponent
    },
    data() {
      return {
        tabCollapsed: false,
        raceTimeFilter: 1,
        date: 100,
        HRcategory: [],
        horseRacesRunners: [[]],
        raceOdds: {},
        name: '',
        category: '',
        categoryCss: '',
        index: 0,
        active: false,
        hrTimeFilter: HORSE_RACING_TIME_FILTERS,
        loading: false,
        apiInterval: null,
        loadingSpinner: ICON_CLASS.LOADING,
        useVideoWidget: APP_SETTINGS.lco.useVideoWidget,
        outrightSports: [],
        showBettingEndDate: APP_SETTINGS.settings.showBettingEndDate,
        showForeCastTricats: false,
        BET_TYPES: RACING_BETTING_TYPES,
        betType: RACING_BETTING_TYPES.WINNER_EW,
      };
    },
    props: {
      tournamentId: {
        type: String,
        default: "",
      },
      sportName: {
        type: String,
        default: "",
      }
    },
    created() {
      useForeCastTricast().then(val => {
        if (val) {
          this.showForeCastTricats = val;
        }
      });
      store.commit('hideAfterRouteWidgets');

      this.date = DateFilterService.parseDateFilter(this.$route.params.fixtureDateFilter);

      if (this.$route.query.rnum) {
        this.raceTimeFilter = +this.$route.query.rnum;
      }
      this.getHorseRaceingData(this.tournamentId || this.$route.params.raceId, this.date);
      if (this.$route.name === 'sports') {
        this.getTournamentOutrights(this.tournamentId || this.$route.params.raceId, this.date);
      }
    },
    mounted() {
      this.setApiInterval();
    },
    destroyed() {
      this.clearApiInterval();
    },
    computed: {
      showWeatherAndTrackData() {
        return this.selectedSport === this.horseRacingSportId || this.tournamentId.startsWith('hr');
      },
      horseRacingSportId() {
        return store.state.SportsModule.hrSportId;
      },
      greyhoundRacingSportId() {
        return store.state.SportsModule.ghSportId;
      },
      nonRunners() {
        if (!this.HRcategory[0]) {
          return [];
        }
        return this.HRcategory[0].tabs[0].horseRaces[this.index].nonRunners;
      },
      selectedSport() {
        if (this.tournamentId !== '') {
          return this.tournamentId.startsWith('hr') ? this.horseRacingSportId : this.greyhoundRacingSportId;
        }
        return parseInt(this.$route.params.sportId, 10);
      },
      emptyStateIcon() {
        if (this.selectedSport === this.horseRacingSportId) {
          return ICON_CLASS.HORSE;
        }
        return ICON_CLASS.GREYHOUND;
      },
      getBtnForeCastTextHr() {
        if (raceCastState.loading) {
          return this.$translate.text('mobile.pleasewait');
        }
        let makeSelection = this.$translate.text('Public.MakeSelection');
        let addToBetslip = this.$translate.text('Public.RaceAddToBetslip');
        if (typeof raceCastState.raceOdd.oo === 'undefined') {
          return makeSelection.replace('${betType}', this.betType)
        } 
        const formatedOdd = formatOddDisplay(raceCastState.raceOdd.oo, this.$root.oddFormat);
        return addToBetslip.replace('${odd}', formatedOdd);
      },
      getRaceDescription(){
        return this.$translate.text('Public.RaceDescription').replace('${betType}', this.betType);
      },
      btnActive() {
        return !(!raceCastState.raceOdd.oo 
          || (+raceCastState.raceOdd.oo) === 1
          || this.raceOdds.raceStatusId === HORSE_RACING_STATUSES.RUNNING
          || this.raceOdds.raceStatusId === HORSE_RACING_STATUSES.RESULTS);
      }
    },
    watch: {
      $route(to, from) {
        const raceDateFilter = +to.params.raceDateFilter;
        if (raceDateFilter && raceDateFilter !== this.date) {
          this.date = raceDateFilter;
          this.selectDate();
        }
        const rnum = +to.query.rnum;
        if (rnum && rnum !== this.raceTimeFilter) {
          this.selectTimeOnRouteChange(rnum);
        }
        const raceId = to.params.raceId;
        if (raceId && raceId !== from.params.raceId) {
          // call the getHorseRaceingData method with the new race ID and date
          this.getHorseRaceingData(to.params.raceId, this.date);
        }
      },
    },
    methods: {
      addCastToBetslip() {
        if (!this.btnActive) {
          return;
        }
        const { betslip_item,betslipMatchItem } = 
          mapCastToBetslip(raceCastState.raceOdd, this.raceOdds, this.horseRacingSportId, raceCastState.runnersDetails);

        const error = addItem(betslip_item, betslipMatchItem);
        showBetslipValidation(error);
        if (!error) {
          placeQuickBet(betslip_item);
        }
      },
      toggleCast(ev) {
         if ((this.raceOdds.raceStatusId === HORSE_RACING_STATUSES.RUNNING
          || this.raceOdds.raceStatusId === HORSE_RACING_STATUSES.RESULTS || ev.runner.outcomes.length === 0 || !ev.runner.outcomes[0].isPublished)) {
          return;
        }
        const odd = ev.odd;
        const runner = ev.runner;
        const item = {
          ...runner,
          type: odd.id === 'Any' ? RACE_CAST_ITEM_TYPE.ANY : RACE_CAST_ITEM_TYPE.REGULAR,
          Order: odd.id,
          id: runner.externalRunnerID,
        };
        toggleCastItem(item, this.raceOdds.outrightID, this.betType);
      },
      setApiInterval() {
        this.clearApiInterval();
        if (parseInt(this.date, 10) !== HORSE_RACING_TIME_FILTERS.RESULTS) {
          this.apiInterval = setInterval(() => {
            const id = this.HRcategory[0].tabs[0].horseRaces[this.index].outrightID;
            this.updateHrOdds(id, false);
          }, 30000);
        }
      },
      selectBetType(betType) {
        this.betType = betType;
        resetRaceCast();
       
        const items = this.horseRacesRunners.flat();
        this.horseRacesRunners = this.horseRacesRunnersSort(items, this.raceOdds.raceStatusId);
      },
      clearApiInterval() {
        clearInterval(this.apiInterval);
      },
      toggleCollapse() {
        this.tabCollapsed = !this.tabCollapsed;
      },
      closeTournamentTab() {
        EventBus.$emit('closeTournamentTab', this.tournamentId);
      },
      selectTime(time, idx, id, status) {
        this.selectedRaceOutrightId = id;
        this.raceTimeFilter = time;
        if (this.$route.query.rnum) {
          this.$router.push({ query: { rnum: time } });
        }
        this.index = idx;
        this.betType = this.BET_TYPES.WINNER_EW;
        this.updateHrOdds(id, status);
      },
      selectTimeOnRouteChange(rnum) {
        if (!this.HRcategory
          || !this.HRcategory[0]
          || !this.HRcategory[0].tabs
          || !this.HRcategory[0].tabs[0]
          || !this.HRcategory[0].tabs[0].horseRaces) {
          return;
        }
        const hrIdx = this.HRcategory[0].tabs[0].horseRaces.findIndex(hr => hr.raceNumber === rnum);
        if (hrIdx === -1 && rnum === 1) {
          return;
        }
        if (hrIdx === -1) {
          this.$router.push({ query: { rnum: 1 } });
          return;
        }
        const race = this.HRcategory[0].tabs[0].horseRaces[hrIdx];
        this.selectTime(rnum, hrIdx, race.outrightID, race.raceStatusId);
      },
      selectDate() {
        this.$router.push({ params: { raceDateFilter: this.date }, query: this.$route.query });
        return this.getHorseRaceingData(this.tournamentId || this.$route.params.raceId, this.date);
      },
      horseRacesRunnersSort(data, status) {
        const items = data.sort((a, b) => {
          if (status === 4) {
            const aOut = (a.runnerPosition && (+a.runnerPosition)) || 100;
            const bOut = (b.runnerPosition && (+b.runnerPosition)) || 100;
            return aOut - bOut;
          } else {
            const aOut = (a.outcomes && a.outcomes[0] && (+a.outcomes[0].outcome)) || 0;
            const bOut = (b.outcomes && b.outcomes[0] && (+b.outcomes[0].outcome)) || 0;
            return aOut - bOut;
          }
        }); // array, filled with values
        const runners = chunkArrayExact(items, this.betType === 1 ? 3 : 2); //we create it, then we'll fill it

        return runners;
      },
      getIconStatusClass(status) {
        return HORSE_RACING_STATUSES_CLASES[status] ? `bto-sb-horse-status ${HORSE_RACING_STATUSES_CLASES[status]}` : '';
      },
      getOddsStatusClass(status) {
        return HORSE_RACING_EVENT_STATUS_CLASSES[status] || '';
      },
      getHorseRaceingData(tournamentId, timeFilter) {
        let tournamentMatchesRequest = new HorseRacingOutrightsRequestService();
        tournamentMatchesRequest.getParams.TournamentData = tournamentId.replace(/[hr, gh]/g, '');
        tournamentMatchesRequest.getParams.TournamentGroupData = [];
        // tournamentMatchesRequest.getParams.CategoryData
        tournamentMatchesRequest.getParams.TimeFilter = timeFilter;
        this.loading = true;
        this.HRcategory = [];
        tournamentMatchesRequest.execute((response) => {
          if (!response.data || response.data.length === 0) {
            return;
          }
          let data = response.data.map(t => new HorseRacingModel(t));
          this.$emit('horseRaceSportName', data[0].name);
          this.HRcategory = data;
          this.name = this.HRcategory[0].tabs[0].tournamentName;
          this.category = this.HRcategory[0].tabs[0].categoryName;
          this.categoryCss = this.HRcategory[0].tabs[0].categoryCss;
          let index = this.HRcategory[0].tabs[0].horseRaces.findIndex(t => t.raceNumber === this.raceTimeFilter);
          this.index = index;
          if (index === -1) {
            this.raceTimeFilter = 1;
            this.index = 0;
          }
          this.horseRacesRunners = [[]];
          const items = data[0].tabs[0].horseRaces[this.index].matchOdds;
          this.raceOdds = data[0].tabs[0].horseRaces[this.index];
          this.horseRacesRunners = this.horseRacesRunnersSort(items, this.raceOdds.raceStatusId);
        }).finally(() => {
          this.loading = false;
        });
      },
      getTournamentOutrights(tournamentId, timeFilter) {
        let tournamentOutrightsRequest = new TournamentOutrightsRequestService();
          const tournamentData = tournamentId.replace('hr', '').replace('gh', '');
          tournamentOutrightsRequest.getParams.tournamentData =  [tournamentData];
          tournamentOutrightsRequest.getParams.TimeFilter = timeFilter;
          tournamentOutrightsRequest.execute((response) => {
            response.data.forEach(s => {
              let responseSport = new FullSportModel(s);
              this.outrightSports = responseSport.tabs;
            });
          }, (error) => {
            console.error(error); // eslint-disable-line
          }).finally(() => {
            this.loading = false;
          });
      },
      updateHrOdds(id, showLoading = true) {
        let tournamentMatchesRequest = new HorseRacingOddsDetails();
        tournamentMatchesRequest.getParams.outrightID = id;
        if (showLoading) {
          this.loading = true;
          this.horseRacesRunners = [[]];
        }
        tournamentMatchesRequest.execute((response) => {
          let data = response.data.map(a => new HRMatchModel(a));
          if (!showLoading && response.data.length === 0) {
            this.horseRacesRunners = [[]];
          }
          const items = data[0].matchOdds;
          this.raceOdds = data[0];
          this.horseRacesRunners = this.horseRacesRunnersSort(items, this.raceOdds.raceStatusId);
        }).finally(() => {
          this.loading = false;
        });
      },
      getEachWayTextHr() {
        return this.$translate.text('HR.EitherWay')
          .replace('{ewpLabel}', this.raceOdds.ewplabel)
          .replace('{ewpPlace}', this.raceOdds.eachWayPlaces);
      },
      selectedSportIcon() {
        return this.HRcategory[0].id === this.horseRacingSportId ? 'horseracing' : 'greyhoundracing';
      },
    }
  };
</script>